export const initItem = {
  item: "",
  audio: false,
  item_id: 0,
  proposals: [
    {
      proposal: "",
      proposal_id: "",
    },
    {
      proposal: "",
      proposal_id: "",
    },
  ],
}

export const initExtra = {
  native_language: true, // TODO: remove when backend no longer requires it
  wholesome_conditions: true, // TODO: remove when backend no longer requires it
  finished: false,
  isRestarting: undefined,
  elapsed_time: 0,
  general_audio: false,
}

export const initAnswers = {
  version: "",
  langCode: "",
  locale_id: 0,
  status: "",
  data: {
    items: [],
    extra: initExtra,
  },
}

const factoryItem = (id: number) => ({
  answer: `ITEM_DRIVE_${String(id).padStart(2, "0")}_PROPOSAL_2`,
  audio: false,
  device_type: "desktop",
  screen_width: 1920,
  time_initial: 0.2,
})

export const factoryPatch = (isRestarting?: boolean) => {
  return {
    version: "en_US_2.0.0",
    langCode: "en_US",
    locale_id: 2,
    status: "todo",
    data: {
      items: [
        factoryItem(1),
        factoryItem(2),
        factoryItem(3),
        factoryItem(4),
        factoryItem(5),
        factoryItem(6),
        factoryItem(7),
        factoryItem(8),
        factoryItem(9),
        factoryItem(10),
        factoryItem(11),
        factoryItem(12),
        factoryItem(13),
        factoryItem(14),
        factoryItem(15),
        factoryItem(16),
        factoryItem(17),
        factoryItem(18),
        factoryItem(19),
        factoryItem(20),
        factoryItem(21),
        factoryItem(22),
        factoryItem(23),
        factoryItem(24),
        factoryItem(25),
        factoryItem(26),
        factoryItem(27),
        factoryItem(28),
        factoryItem(29),
        factoryItem(30),
        factoryItem(31),
        factoryItem(32),
        factoryItem(33),
        factoryItem(34),
        factoryItem(35),
        factoryItem(36),
        factoryItem(37),
        factoryItem(38),
        factoryItem(39),
        factoryItem(40),
        factoryItem(41),
        factoryItem(42),
        factoryItem(43),
        factoryItem(44),
        factoryItem(45),
        factoryItem(46),
        factoryItem(47),
        factoryItem(48),
        factoryItem(49),
        factoryItem(50),
        factoryItem(51),
        factoryItem(52),
        factoryItem(53),
        factoryItem(54),
        factoryItem(55),
        factoryItem(56),
        factoryItem(57),
        factoryItem(58),
        factoryItem(59),
        factoryItem(60),
        factoryItem(61),
        factoryItem(62),
        factoryItem(63),
        factoryItem(64),
        factoryItem(65),
        factoryItem(66),
        factoryItem(67),
        factoryItem(68),
        factoryItem(69),
        factoryItem(70),
        factoryItem(71),
        factoryItem(72),
        factoryItem(73),
        factoryItem(74),
        factoryItem(75),
        factoryItem(76),
        factoryItem(77),
        factoryItem(78),
        factoryItem(79),
        factoryItem(80),
        factoryItem(81),
        factoryItem(82),
        factoryItem(83),
        factoryItem(84),
        factoryItem(85),
        factoryItem(86),
        factoryItem(87),
        factoryItem(88),
      ],
      extra: { ...initExtra, isRestarting }, // Override isRestarting if provided
    },
  }
}

export const factoryReset = {
  version: "en_US_2.0.0",
  langCode: "en_US",
  locale_id: 2,
  status: "todo",
  data: {
    items: [],
    extra: { ...initExtra },
  },
}
